module.exports = __webpack_public_path__ + "images/fc732ed5695fdd5456eaef1efa5f8bd8.png";